<div class="head">
  <h1>{{ title }}</h1>
</div>
<div class="content">
  <form #form="ngForm">
    <ng-container *ngIf="ppi && werkbon"><!--wacht op init-->
      <p><b>Dienst</b></p>
      <div class="form-row">
        <div class="w-col-sm-4 mb-2">
          <div class="form-group">
            <label [for]="id('project')">Project</label>
            <input type="text" readonly class="form-control" [id]="id('project')" name="project"
                   [(ngModel)]="ppi.project.omschrijving">
          </div>
        </div>
        <div class="w-col-sm-4 mb-2">
          <div class="form-group">
            <label [for]="id('functie')">Functie</label>
            <input type="text" readonly class="form-control" [id]="id('functie')" name="functie"
                   [(ngModel)]="ppi.planitem.functionlabel">
          </div>
        </div>
        <div class="w-col-sm-4 w-col-lg-2 mb-2">
          <div class="form-group">
            <label [for]="id('datum')">Datum</label>
            <sihwdatumveld [disabled]="true" class="form-control" [id]="id('datum')" name="datum"
                           [(ngModel)]="ppi.planitem.startdate"></sihwdatumveld>
          </div>
        </div>
        <div class="w-col-sm-2 w-col-lg-1 mb-2">
          <label [for]="id('van')">Van</label>
          <sihwtijdveld [disabled]="true" [voorloopnul]="true" class="form-control" [id]="id('van')" name="van"
                        [(ngModel)]="ppi.planitem.starttime"></sihwtijdveld>
        </div>
        <div class="w-col-sm-2 w-col-lg-1 mb-2">
          <label [for]="id('tot')">Tot</label>
          <sihwtijdveld [disabled]="true" [voorloopnul]="true" class="form-control" [id]="id('tot')" name="tot"
                        [(ngModel)]="ppi.planitem.endtime"></sihwtijdveld>
        </div>
      </div>
      <div class="form-row mt-3">
        <div class="w-col-6">
          <p><b>Ingediende tijden</b></p>
          <div class="form-row">
            <div class="w-col-sm-6 w-col-lg-4 mb-2">
              <label [for]="id('wbvanbon')">Van</label>
              <sihwtijdveld [disabled]="true" [voorloopnul]="true" class="form-control" [id]="id('wbvanbon')"
                            name="wbvanbon"
                            [(ngModel)]="werkbon.starttijd"></sihwtijdveld>
            </div>
            <div class="w-col-sm-6 w-col-lg-4 mb-2">
              <label [for]="id('wbtotbon')">Tot</label>
              <sihwtijdveld [disabled]="true" [voorloopnul]="true" class="form-control" [id]="id('wbtotbon')"
                            name="wbtotbon"
                            [(ngModel)]="werkbon.eindtijd"></sihwtijdveld>
            </div>
          </div>
        </div>
        <div class="w-col-6">
          <p><b>Overschijf de tijden </b><span class="inforondje" title="De tijden die je hier invult gaan altijd voor op de ingediende tijden. Laat of maak het leeg als je de normale logica wilt gebruiken."></span> </p>
          <div class="form-row">
            <div class="w-col-sm-6 w-col-lg-4 mb-2">
              <label [for]="id('wbvanoverrule')">Van</label>
              <sihwtijdveld [disabled]="readonly" [voorloopnul]="true" class="form-control" [id]="id('wbvanoverrule')"
                            name="wbvanoverrule"
                            [(ngModel)]="werkbon.overrule_starttijd"></sihwtijdveld>
            </div>
            <div class="w-col-sm-6 w-col-lg-4 mb-2">
              <label [for]="id('wbtotoverrule')">Tot</label>
              <sihwtijdveld [disabled]="readonly" [voorloopnul]="true" class="form-control" [id]="id('wbtotoverrule')"
                            name="wbtotoverrule"
                            [(ngModel)]="werkbon.overrule_eindtijd"></sihwtijdveld>
            </div>
          </div>
        </div>
      </div>
      <p class="mt-3"><b>Werkbon </b> <em>{{ readonly ? 'alleen lezen' : 'aanpasbaar' }} </em><span class="inforondje" title="De aanpassingen die je hier maakt worden gewoon als ingediende gegevens opgeslagen."></span></p>
      <div class="form-row">
        <div class="w-col-sm-3 w-col-lg-2 mb-2">
          <label [for]="id('pauze')">Pauze (min)</label>
          <input type="number" [disabled]="readonly" min="0" max="120" class="form-control" [id]="id('pauze')" required
                 name="pauze" [(ngModel)]="werkbon.pauze">
        </div>
        <div class="w-col-sm-3 w-col-lg-2 mb-2">
          <label [for]="id('kilometers')">KM Project</label>
          <input type="number" [disabled]="readonly" min="0" max="5000" class="form-control" [id]="id('kilometers')"
                 required
                 name="kilometers" [(ngModel)]="werkbon.kilometers">
        </div>
        <div class="w-col-sm-3 w-col-lg-2 mb-2">
          <label [for]="id('kilometers_ww')" title="Kilometers Woon-Werk">KM W-W</label>
          <input type="number" [disabled]="readonly" min="0" max="5000" class="form-control" [id]="id('kilometers')"
                 required
                 name="kilometers_ww" [(ngModel)]="werkbon.kilometers_ww">
        </div>
        <div class="w-col-sm-10 w-col-lg-6 mb-2">
          <label [for]="id('ondertekenaar')">Ondertekenaar</label>
          <input *ngIf="! werkbon.proforma" type="text" disabled [id]="id('ondertekenaar')" name="ondertekenaar"
                 class="form-control"
                 [(ngModel)]="werkbon.ondertekenaar">
          <input *ngIf="werkbon.proforma" type="text" disabled [id]="id('ondertekenaar')" name="ondertekenaar"
                 class="form-control"
                 value="(proforma)">
        </div>
      </div>
      <div class="mt-3 mb-3">
        <label [for]="id('opmerkingen')">Opmerkingen</label>
        <textarea [disabled]="readonly" [id]="id('opmerkingen')" name="opmerkingen" class="form-control"
                  [(ngModel)]="werkbon.opmerkingen"></textarea>
      </div>
      <ng-container *ngIf="werkbon.handtekening">
        <div class="mb-3">
          <p><b>Handtekening</b></p>
          <img class="handtekening" [src]="werkbon.handtekening" alt="Handtekening">
        </div>
      </ng-container>
    </ng-container>
  </form>
</div>
<div class="foot">
  <div class="buttons" links>
    <button class="btn btn-secondary" (click)="closeWindow(gewijzigd)">{{ form.pristine ? 'Sluiten' : 'Annuleren' }}
    </button>
    <button class="btn btn-secondary" [disabled]="form.invalid"
            (click)="pdf()">{{ readonly ? 'PDF' : 'Opslaan &amp; PDF' }}
    </button>
  </div>
  <div class="buttons" rechts>
    <button class="btn btn-primary" (click)="save()" *ngIf="! readonly" [disabled]="form.invalid">
      Opslaan &amp; sluiten
    </button>
  </div>
</div>
